export let chatInputStorageKey = 'chat-';
export let roomChatUnsentMessageStorageKey = 'rum-chat-';
export let dialogueChatUnsentMessageStorageKey = 'dum-chat-';
